<template>
  <div class="location-pop" v-show="value">
    <div class="mask"></div>
    <div class="content">
      <div class="current">
        <p>当前城市：深圳</p>
        <i class="el-icon-close close" @click="close"></i>
      </div>
      <div class="search-wrap">
        <el-input
          size="large"
          placeholder="请输入城市名称搜索，开始找房"
          suffix-icon="el-icon-search"
          v-model.trim="searchValue"
          clearable>
        </el-input>
      </div>
      <div>
        <div class="hot-city" v-if="showHotCityList && showHotCityList.length">
          <span class="title">热门城市：</span>
          <span class="city" v-for="(item, index) in showHotCityList" :key="index" @click="choseCity(item.value)">{{ item.value.pageName }}</span>
        </div>
        <div class="chose-city">
          <p class="title">选择城市</p>
          <div class="city-list" v-if="showCityList && showCityList.length">
            <div v-for="(item, j) in showList" :key="j" class="letter-city-wrap" :class="{ml50: j%2}">
              <div class="letter">{{ item.label }}</div>
              <div class="cityName">
                <span v-for="(sub, k) in item.value" :key="k" @click="choseCity(sub)">{{ sub.pageName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'city-location',
  props: {
    value: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      showCityList: [],
      showHotCityList: [],
      searchValue: '',
      showList: []
    }
  },
  methods: {
    init () {
      this.$api.getCityList().then(res => {
        if (res.code === 200) {
          const arr1 = []
          const cityList = res.data
          for (let key in cityList) {
            let obj = {
              label: key,
              value: cityList[key]
            }
            arr1.push(obj)
          }

          this.showCityList = arr1
          this.showList = this.showCityList
        } else {
          this.$message.error(res.msg)
        }
      })
      this.$api.getHotCityList().then(res => {
        if (res.code === 200) {
          const arr2 = []
          const hotCityList = res.data
          for (let key in hotCityList) {
            let obj = {
              label: key,
              value: hotCityList[key]
            }
            arr2.push(obj)
          }
          this.showHotCityList = arr2
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    close () {
      this.$emit('input', false)
    },
    choseCity (val) {
      this.$api.getExhibitionHallHome(val.pageId).then(res => {
        const cityId = res.data.cities[0].id || '1988'
        this.$store.commit('SET_CITYID', cityId)
      })
      this.$store.commit('SET_HOMPAGEID', { id: val.pageId, name: val.pageName })
      this.$emit('input', false)
    }
  },
  watch: {
    searchValue: {
      handler( val ){
        if (val === '') {
          this.showList = this.showCityList
        } else {
          this.showList = []
          // 处理showCityList数据，将里面的包含关键字消息的对象提取出来再组装成showCityList相同的结构
          let obj = [];
          Object.values(this.showCityList).forEach(value => {
            value.value.forEach((a)=>{
              obj.push(a)
            })
          })
          const str = {
            label:'#',
            value:[]
          }
          obj.forEach(value => {
            if(value.pageName.indexOf(this.searchValue) !== -1){
              obj = value
              str.value.push(obj)
            }
          })


          const str1 = [];
          str1.push(str)
          this.showList = str1
        }
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
.location-pop{
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  .mask{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9;
  }
  .content{
    position: absolute;
    width: 660px;
    padding-bottom: 8vh;
    background: #fff;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    z-index: 1000;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .current{
      @include font16(500, #2D2E30);
      box-sizing: border-box;
      width: 100%;
      height: 56px;
      border-bottom: 1px solid #E7EAF0;
      line-height: 56px;
      padding: 0 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .close{
        color: #B4B8C0;
        font-size: 16px;
        cursor: pointer;
        padding: 5px;
      }
    }
    .search-wrap{
      padding: 22px 24px;
    }
    .hot-city {
      padding: 0 24px;
      margin-bottom: 40px;
      .title{
        @include font14(400, #9399A5);
      }
      .city{
        @include font14(400, #333333);
        margin-right: 24px;
        cursor: pointer;
      }
    }
    .chose-city{
      padding: 0 24px;
      .title{
        @include font16(500, #333333);
      }
      .city-list{
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 600px;
        max-height: 448px;
        height: 45vh;
        overflow-x: hidden;
        overflow-y: auto;
        .letter-city-wrap{
          width: 270px;
          display: flex;
          justify-content: flex-start;
          margin-bottom: 8px;
          .letter{
            @include font14(400, #9399A5);
            padding-right: 16px;
            line-height: 28px;
          }
          .cityName{
            width: 240px;
            span{
              display: inline-block;
              @include font14(400, #333333);
              padding: 0 8px;
              line-height: 28px;
              cursor: pointer;
              &:hover{
                color: tomato;
              }
            }
          }
        }
      }
    }
  }
}
</style>
